import { render, staticRenderFns } from "./ArrangeItem.vue?vue&type=template&id=6c3db2f8&scoped=true"
import script from "./ArrangeItem.vue?vue&type=script&lang=js"
export * from "./ArrangeItem.vue?vue&type=script&lang=js"
import style0 from "./ArrangeItem.vue?vue&type=style&index=0&id=6c3db2f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3db2f8",
  null
  
)

export default component.exports